import {
    Button,
    Dialog, DialogContent, List, Paper, Typography
} from '@material-ui/core'
import { AccessAlarmOutlined } from '@material-ui/icons'
import * as React from 'react'
import { useHistory } from 'react-router-dom'

import { buttonsStyles } from '../../styles/ButtonsStyles'
import { escapeRoomStyles } from '../../styles/EscapeRoomStyles'
import { textStyles } from '../../styles/TextStyles'
import { formatTimeline } from '../../utils/helper'
import { EscapeRoomDto, StartedGameDto } from '../../utils/types'

interface Props {
    open: boolean
    onClose(): void
    onStart(): void
    onMonitor(): void
    escapeRoom: EscapeRoomDto
    startedGame?: StartedGameDto
}

export const EscapeRoomDetailsModal: React.FC<Props> = ({
    onClose,
    onStart,
    onMonitor,
    open,
    escapeRoom,
    startedGame
}) => {
    const history = useHistory()
    const eRoomStyles = escapeRoomStyles()
    const tStyles = textStyles()
    const btnStyles = buttonsStyles()
    // const classes = containerStyles()

    const totalTime = escapeRoom.puzzles.map((pz) => pz.seconds).reduce((p, c) => p + c, 0)
    return (
        <Dialog
            className={eRoomStyles.dialog}
            open={open}
            keepMounted
            aria-describedby="alert-dialog-slide-description">
            <div style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${escapeRoom.bannerImageUri})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                width: 600,
                height: 250,
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
            }}>
                <Button className={btnStyles.closeModalE} onClick={onClose}>X</Button>
            </div>

            <div className={eRoomStyles.divTittle}>
                <Typography className={tStyles.escapeRoomTittle}>{escapeRoom.title}</Typography>
                {startedGame && (
                    <Button
                        className={btnStyles.monitorBtn}
                        onClick={onMonitor}>
                        Spilovervågning
                    </Button>
                )}

            </div>

            <DialogContent className={eRoomStyles.dialogContent}>

                <div className={eRoomStyles.fullDescription}>
                    {escapeRoom && (
                        <DialogContent
                            className={eRoomStyles.contentText}
                            id="alert-dialog-slide-description">

                            {escapeRoom.description}
                            {escapeRoom.descriptionImageUri && (
                                <div className={eRoomStyles.wrapImageDescription}>
                                    <img
                                        className={eRoomStyles.imageDescription}
                                        src={escapeRoom.descriptionImageUri}
                                        alt={escapeRoom.title}/>
                                </div>
                            )}

                        </DialogContent>
                    )}
                </div>

                {escapeRoom.materials.map((m) => {
                    return (
                        <p>{m.key}</p>
                    )
                })}
                <Paper className={eRoomStyles.scrollViewPaper}>
                    <List className={eRoomStyles.scrollViewList}>
                        {escapeRoom.puzzles.map((pz, index) => {
                            return (
                                <div key={index.toString()} style={{ display: 'flex' }}>
                                    <div
                                        onClick={() => history.push(`/opgaver?selected=${pz.puzzleId}`)}
                                        style={{
                                            width: 150,
                                            height: 150,
                                            borderRadius: 20,
                                            margin: 10,
                                            backgroundImage:
                                                `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)),
                                                 url(${pz.materialImage})`,
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: 'cover',
                                            cursor: 'pointer',
                                            transition: 'transform 0.2s',
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                                        <span className={eRoomStyles.smallCardInfo}>
                                            <AccessAlarmOutlined/>
                                            {formatTimeline(pz.seconds)}

                                        </span>
                                        <span className={eRoomStyles.smallCardInfo}>
                                            {pz?.puzzleId}
                                        </span>

                                    </div>
                                </div>
                            )
                        })}
                    </List>
                </Paper>
                <div className={eRoomStyles.totalTimeWrap}>
                    <AccessAlarmOutlined className={tStyles.primaryWhite}/>
                    <p className={tStyles.primaryWhite}>Samlet tid {formatTimeline(totalTime)}</p>
                </div>

            </DialogContent>
            <Button
                className={btnStyles.createBtn}
                onClick={onStart}>
                {startedGame ? 'Genoptag Spil' : 'Start Spil'}
            </Button>
        </Dialog>
    )
}

EscapeRoomDetailsModal.defaultProps = {
    startedGame: undefined
}
